<template>
  <div>
    <el-form
      :model="newDomain"
      :rules="rules"
      ref="form"
      hide-required-asterisk
      label-position="top"
      class="brand-input brand-validation"
      @submit.prevent.native="submit()"
    >
      <div class="px-8 pt-6 pb-6">
        <p class="text-xl font-bold mb-4 text-brand-black">Add Checkout Domain</p>
        <p class="text-sm font-medium text-brand-brown mb-4">
          This will point your custom domain to our payment recovery page. It must be a subdomain (e.g. billing.yourdomain.com).
        </p>
        <el-form-item prop="url" label="Domain name" class="font-bold text-left pb-2">
          <el-input placeholder="billing.yourdomain.com" type="text" v-model="newDomain.url">
            <template slot="prepend">https://</template>
          </el-input>
        </el-form-item>
      </div>
      <!-- Cancel / Submit-->
      <div class="bg-brand-light-sand border-t-2 border-brand-sand flex justify-end px-8 py-4 rounded-b-lg">
        <el-button
          @click="
            resetForm();
            close();
          "
          type="plain"
          class="border-brand-gray-blue border-2 px-6 py-2 rounded-lg"
        >
          <span class="text-sm text-brand-blue font-semibold">Nevermind</span>
        </el-button>
        <el-button native-type="submit" type="primary" class="font-bold py-2 px-6 rounded-lg text-sm" :loading="isLoading"
          >Add Checkout Domain</el-button
        >
      </div>
    </el-form>
  </div>
</template>

<script>
const rules = {
  url: [{ required: true, message: 'Domain name is required', trigger: 'blur' }],
};

export default {
  data() {
    return {
      isLoading: false,
      newDomain: {
        url: '',
      },
      rules,
    };
  },
  props: {
    close: {
      type: Function,
    },
    action: {
      type: Function,
      required: true,
    },
  },
  methods: {
    resetForm() {
      this.$refs.form.resetFields();
    },
    async submit() {
      if (!this.$refs.form) return;
      await this.$refs.form.validate((valid) => {
        if (valid) {
          this.addDomainName();
        }
      });
    },
    async addDomainName() {
      try {
        this.isLoading = true;
        const protocol = new RegExp('^(http|https)://', 'i');
        const customDomain = this.newDomain.url.replace(protocol, '');
        await this.action({ customDomain });
        this.close();
        this.isLoading = false;
        this.resetForm();
      } catch (error) {
        this.error = error;
      }
    },
  },
};
</script>
